module.exports = __webpack_public_path__ + "static/media/1 chest four horsemen apocalypse.1280x1707.88509f8b.webp";